<template>
    <button type="button" class="sps-card sps-card--ask" @click="$emit('ask')">
        <div class="sps-card__text">
            <div class="sps-card__title">{{ hasActiveChat ? $t("shell.continueChat") : (lc.title || $t("shell.askTitle")) }}</div>
            <div class="sps-card__sub">{{ hasActiveChat && preview ? preview : (lc.subtitle || $t("shell.askSubtitle")) }}</div>
        </div>
        <span class="sps-card__chevron" aria-hidden="true">›</span>
    </button>
</template>
<script>
import { mapGetters, mapState } from "vuex";
import { pickLanguageContent } from "../../../../utils/shell/pickLanguageContent";
import { pickPreview } from "../../../../utils/chatHistoryList";
export default {
    name: "AskCard",
    props: { card: { type: Object, required: true } },
    computed: {
        ...mapGetters({ hasActiveChat: "shell/hasActiveChat" }),
        ...mapState({ defaultLocale: (s) => s.catalog.defaultLocale, conversations: (s) => s.shell.conversations, conversationId: (s) => s.chat.conversationId }),
        lc() { return pickLanguageContent(this.card.languageContent, this.$i18n.locale, this.defaultLocale) || {}; },
        preview() { const c = this.conversations.find((x) => x._id === this.conversationId); if (c && c.ai && c.ai.summary && c.ai.final !== false) return c.ai.summary; const p = c && pickPreview(c.messages); return p ? p.text : ""; },
    },
};
</script>



// WEBPACK FOOTER //
// src/components/V2/shell/cards/AskCard.vue